import YoungPersonLocationStatusSelectView from './YoungPersonLocationStatusSelectViewContainer';
export default YoungPersonLocationStatusSelectView;
